<template>
  <v-menu min-width="25vw" max-width="100vw" offset-y relative z-index="99">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-apps</v-icon>
      </v-btn>
    </template>
    <v-card class="pa-2">
      <v-container fluid>
        <v-row>
          <v-col cols="4" large v-for="(item, index) in items" :key="index">
            <router-link :to="item.to" class="d-flex flex-column text-center py-4 app-link">
              <v-icon x-large color="red">{{ item.icon }}</v-icon>
              <span class="pt-1 grey--text text--darken-4">{{ item.text}}</span>
            </router-link>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
  
</template>

<script>
export default {
  data: () => ({
    items: [
      { icon: "mdi-home", text: "Domov", to: "/" },
      { icon: "mdi-car-off", text: "Škode", to: "/skode" },
      { icon: "mdi-cog", text: "Nastavitve", to: "/nastavitve" },
      { icon: "mdi-information-outline", text: "O programu", to: "/about" }
    ]
  })
};
</script>

<style>
.app-link {
  text-decoration: none;
}

.app-link:hover {
  outline: 1px dashed rgba(255,0,0, 0.5);
}

</style>